
import React from "react";
import { logClientError } from "../services/systemLogs";
import { reloadForChunkLoadError } from "../utils/chunkLoadRecovery";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
    logClientError("react.error_boundary", error, {
      componentStack: errorInfo?.componentStack || "",
    });
    reloadForChunkLoadError(error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <h1>Something went wrong.</h1>
          <button
            className="btn_blue"
            onClick={() => {
              window.location.reload();
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
